import{_ as r}from"./_getNative.js";var t=r,e=function(){try{var r=t(Object,"defineProperty");return r({},"",{}),r}catch(r){}}();export{e as _};
